import type { InvoiceRowData } from "@/components/shared/data-table";
import { InvoiceType } from "@/lib/constants/invoice-type";
import type { CellContext } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

export const InvoiceTypeCell = ({
  row,
}: CellContext<InvoiceRowData, unknown>) => {
  const { t } = useTranslation();
  const invoiceType = row.original.invoice.type;

  if (!invoiceType) {
    return null;
  }

  const isReceivable = invoiceType === InvoiceType.RECEIVABLE;

  return (
    <div className="flex items-center gap-1">
      {isReceivable
        ? t("invoices-table.invoice_type.receivable")
        : t("invoices-table.invoice_type.payable")}
    </div>
  );
};
